import { render } from "./ContributionReceipt.vue?vue&type=template&id=0c5b94d3&scoped=true"
import script from "./ContributionReceipt.vue?vue&type=script&lang=js"
export * from "./ContributionReceipt.vue?vue&type=script&lang=js"

import "./ContributionReceipt.vue?vue&type=style&index=0&id=0c5b94d3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5b94d3"]])

export default __exports__